<template>
  <ion-toolbar class="shift-toolbar">
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack('userForm')">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Shift Visibility</ion-title>
    <!-- <ion-buttons slot="end">
        <ion-button @click="goNext('userForm')" :disabled="isNextButtonDisabled">
          <span>Next</span>
        </ion-button>
      </ion-buttons> -->
  </ion-toolbar>

  <div class="main_wrapper radio-outer ion-padding">
    <div class="container">
      <!-- <div>
          <div class="title choose-grp">Choose which groups can see your shift</div>
        </div> -->
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Shift Visibility</h1>
          <p class="auth-subtext">Choose which group can see your shift</p>
        </div>
        <div class="brand-icon">
          <SvgIcon
            name="brandIcon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          />
        </div>
      </div>
      <el-form
        :model="formsData.userForm"
        :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="goNext('userForm')"
      >
        <div class="flex items-center text-sm">
          <el-checkbox-group
            v-model="formsData.userForm.visibility_status.value"
            @change="updateVisibilityOptions"
          >
            <template
              v-for="visibilityOption in visibiltyOptions"
              :key="visibilityOption.value"
            >
              <!-- <el-form-item v-if="visibilityOption.visibility"> -->
              <el-form-item>
                <el-checkbox
                  :label="visibilityOption.value"
                  size="large"
                  :disabled="shouldDisableCheckbox(visibilityOption)"
                >
                  <div class="shift_locum">
                    <span class="label-title"
                      >{{ visibilityOption.label }}
                    </span>
                    <span
                      class="label-sub"
                      v-if="checkSubscriptionEnabledDIsabled(visibilityOption)"
                      >({{ visibilityOption.value === 2 ? pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText : subscriptionAvailiabilityText }})</span
                    >
                    <span
                      class="label-sub"
                      v-else-if="checkLocumAvailability(visibilityOption)"
                      >{{ visibilityOption.noLocum }}</span
                    >
                  </div>
                  <span
                    class="label-sub"
                    v-if="!shouldDisableCheckbox(visibilityOption)"
                    >{{ visibilityOption.description }}</span
                  >
                </el-checkbox>
              </el-form-item>
              <div
                v-if="
                  visibilityOption.value == 1 && visibilityOption.visibility
                "
              >
                <div
                  v-if="formsData.userForm.visibility_status.value.includes(1)"
                  class="pl-4 shift-options"
                >
                  <el-form-item>
                    <common-radio
                      v-model="
                        formsData.userForm.more_option_internal_pool.value.value
                      "
                      :value="
                        formsData.userForm.more_option_internal_pool.value.value
                      "
                    />
                  </el-form-item>
                  <!-- Pharmacy Tags Start -->
                  <el-form-item
                    class="c-outer"
                    v-if="internalEmployeeGroups.length > 0"
                  >
                    <div class="c-notify-title">
                      Notify the following Groups
                      <!-- <div v-if="formsData.userForm.more_option_internal_pool.value.tags.length==0" class="c-error">(Please select at least one Group.)</div>/ -->
                    </div>
                    <div>
                      <el-checkbox-group
                        v-model="
                          formsData.userForm.more_option_internal_pool.value
                            .tags
                        "
                      >
                        <el-checkbox
                          class="c-label"
                          v-for="tag in internalEmployeeGroups"
                          :key="tag.id"
                          :label="tag.id"
                        >
                          <span class="c-agency-name"
                            >{{ tag.title }} ({{ tag.noOfUsers }})</span
                          >
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                  <!-- Pharmacy Tags Ends -->
                  <el-form-item class="c-outer" v-if="guestLocums.length > 0">
                    <div class="c-notify-title">
                      Notify the following guest {{ message.locum }}(s)
                    </div>
                    <div>
                      <el-checkbox-group
                        v-model="
                          formsData.userForm.more_option_internal_pool.value
                            .guestLocums
                        "
                      >
                        <el-checkbox
                          class="c-label"
                          v-for="guestLocum in guestLocums"
                          :key="guestLocum.id"
                          :label="guestLocum.id"
                        >
                          <span class="c-agency-name">{{
                            guestLocum.name
                          }}</span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div
                v-if="
                  visibilityOption.value == 2 && visibilityOption.visibility
                "
              >
                <div
                  v-if="formsData.userForm.visibility_status.value.includes(2)"
                  class="pl-4 shift-options"
                >
                  <el-form-item>
                    <common-radio
                      v-model="
                        formsData.userForm.more_option_prefered_locum.value
                          .value
                      "
                      :value="
                        formsData.userForm.more_option_prefered_locum.value
                          .value
                      "
                    />
                  </el-form-item>
                  <el-form-item class="c-outer">
                    <div class="c-notify-title">
                      Notify the following preferred locum
                      <div
                        v-if="
                          formsData.userForm.more_option_prefered_locum.value
                            .locums.length == 0
                        "
                        class="c-error"
                      >
                        (Please select at least one preferred locum.)
                      </div>
                    </div>
                    <div>
                      <el-checkbox-group
                        v-model="
                          formsData.userForm.more_option_prefered_locum.value
                            .locums
                        "
                      >
                        <el-checkbox
                          class="c-label"
                          v-for="agency in preferedLocums"
                          :key="agency.id"
                          :label="agency.id"
                        >
                          <span class="c-agency-name">{{ agency.name }}</span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div
                v-if="
                  visibilityOption.value == 3 && visibilityOption.visibility
                "
              >
                <div
                  v-if="formsData.userForm.visibility_status.value.includes(3)"
                  class="pl-4 shift-options"
                >
                  <el-form-item>
                    <common-radio
                      v-model="
                        formsData.userForm.more_option_open_marketplace.value
                          .value
                      "
                      :value="
                        formsData.userForm.more_option_open_marketplace.value
                          .value
                      "
                    />
                  </el-form-item>
                  <el-form-item class="c-outer">
                    <div v-if="onboardingFeature === 'true'">
                      <el-checkbox-group
                        v-model="
                          formsData.userForm.more_option_open_marketplace.value
                            .onboarding
                        "
                      >
                        <el-checkbox
                          class="c-label"
                          @click.prevent="handleCheckboxClickForOnboarding()"
                        >
                          <span class="label-title"
                            >I am willing to onboard locum as an employee</span
                          >
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div
                v-if="
                  visibilityOption.value == 4 && visibilityOption.visibility
                "
              >
                <div
                  v-if="formsData.userForm.visibility_status.value.includes(4)"
                  class="pl-4 shift-options"
                >
                  <el-form-item>
                    <common-radio
                      v-model="
                        formsData.userForm.more_option_agency.value.value
                      "
                      :value="formsData.userForm.more_option_agency.value.value"
                    />
                  </el-form-item>
                  <el-form-item class="c-outer">
                    <div class="c-notify-title">
                      Notify the following agencies
                      <div
                        v-if="
                          formsData.userForm.more_option_agency.value.agencies
                            .length == 0
                        "
                        class="c-error"
                      >
                        (Please select at least one agency.)
                      </div>
                    </div>
                    <div>
                      <el-checkbox-group
                        v-model="
                          formsData.userForm.more_option_agency.value.agencies
                        "
                      >
                        <!-- <el-checkbox class="c-label" v-for="agency in agencies" :key="agency.id" :label="agency.id" @click="handleCheckboxClick(agency.id)">
                           <span class="c-agency-name">{{ agency.name }}</span>
                          </el-checkbox> -->
                        <el-checkbox
                          class="c-label"
                          v-for="agency in agencies"
                          :key="agency.id"
                          :label="agency.id"
                        >
                          <span class="c-agency-name">{{ agency.name }}</span>
                          <span
                            class="locumate_icons locumate_icon-info"
                            @click.prevent="
                              handleCheckboxClick(agency.id, $event)
                            "
                          ></span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </template>
          </el-checkbox-group>
        </div>
      </el-form>
      <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon
          name="bgIcon"
          class="bg-icon"
          width="174"
          height="174"
          viewBox="0 0 174 174"
          fill="none"
        />
      </div>
      <el-button
        class="primary w-full mt-auto"
        @click="goNext('userForm')"
        :disabled="isNextButtonDisabled"
      >
        Next
      </el-button>
    </div>
    <el-dialog
      v-model="showDialog"
      modal-class="modal-dialog-custom"
      title="Agency Details"
      width="30%"
    >
      <div class="modal-c">
        <p slot="title"><strong>Name:</strong> {{ selectedAgencyData.name }}</p>
        <p><strong>Email: </strong> {{ selectedAgencyData.email }}</p>
        <p v-if="selectedAgencyData.notes.length > 0">
          <strong> Rate:</strong> {{ selectedAgencyData.notes[0].rate }}
        </p>
        <p v-else><strong> Rate:</strong> $0</p>

        <div class="modal-note" v-if="selectedAgencyData.notes.length > 0">
          <strong>Note </strong>

          <ul class="note-list">
            <!-- <li v-for="note in selectedAgencyData.notes" :key="note.id">{{ note.note }}</li> -->
            <li :key="selectedAgencyData.notes[0].id">
              {{ selectedAgencyData.notes[0].note }}
            </li>
          </ul>
        </div>
        <div class="modal-note" v-else>
          <strong>Note </strong>
          <p>Note not found</p>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer footer-btn">
          <el-button @click="showDialog = false">Close</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  onMounted,
  inject,
  ref,
  computed,
  reactive,
  getCurrentInstance,
} from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formHooks from "@/hooks/form/form";
import CommonRadio from "./CommonRadio.vue";
import SvgIcon from "@/components/Svg/SvgIcon.vue";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";

import { isUSRegion } from "@/helpers/region/regionHelper.js";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    CommonRadio,
    SvgIcon,
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const message = inject("messages");
    const selectedInternalPoolOption = ref(null);
    const guestLocums = ref([]);
    const agencies = ref([]);
    const preferedLocums = ref([]);
    const internalEmployeeGroups = ref([]);
    const jobCreatePageData = $store.getters.getJobCreatePageData;
    const userRootData = $store.getters.GET_USER_DATA;
    const subscription = ref(
      userRootData.calculatedSubscriptions.subscription
        ? userRootData.calculatedSubscriptions.subscription
        : false
    );

    const subscriptionAvailiabilityText = ref(
      userRootData.calculatedSubscriptions.subscriptionAvailiabilityText
    );

    // check if pharmacy is in group and group have active subscription
    const pharmacyIsInGroupAndGroupHaveSubscription = ref(
      userRootData.pharmacyGroupHasSubscription &&
      userRootData.pharmacyGroupHasSubscription.subscription
        ? userRootData.pharmacyGroupHasSubscription.subscription
        : false
    );

    const pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText = ref(
      userRootData.pharmacyGroupHasSubscription?.subscriptionAvailabilityText
    );

    // If pharmacy have subscription but group don't have subscription then show the pharmacy subscription availability text
    if(subscription.value === true && pharmacyIsInGroupAndGroupHaveSubscription.value === false){
      pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText.value = subscriptionAvailiabilityText.value;
    }

    const user = userRootData.shiftVisibilityPercent;
    const agenciesAvailable = userRootData.agencies.length > 0 ? true : false;
    const internalStaffAvailable =
      userRootData.internalStaffs.length > 0 ? true : false;
    const preferedLocumAvailable =
      userRootData.preferredLocumInvitationAccepted.length > 0 ? true : false;
    const visibilityAgencyUser = user.visibilityAgencyUser
      ? user.visibilityAgencyUser
      : null;
    const visibilityAllLocum = user.visibilityAllLocum
      ? user.visibilityAllLocum
      : null;
    const visibilityInternalStaff = user.visibilityInternalStaff
      ? user.visibilityInternalStaff
      : null;
    const visibilityPreferredLocum = user.visibilityPreferredLocum
      ? user.visibilityPreferredLocum
      : null;
    const prevVisibilityStatus = ref([]);
    const isUS = isUSRegion();
    const marketPlaceOff = process.env.VUE_APP_ENABLE_MARKET_PLACE_OFF;
    const selectedAgency = ref(null);
    const instance = getCurrentInstance();
    const isPreferredLocumEnabled = userRootData.settings.preferredLocumEnabled;

    const selectedAgencyData = ref({
      name: "",
      email: "",
      rates: "",
      notes: "",
    });

    const onboardingFeature =
      process.env.VUE_APP_FEATURE_ONBOARD_LOCUM_AS_AN_EMPLOYEE;

    const showDialog = ref(false);

    const visibiltyOptions = [
      {
        label: "Internal pool",
        value: 1,
        description: "Your internal employees or contractors",
        radioOption: "internal_pool",
        percent: visibilityInternalStaff,
        visibility: internalStaffAvailable,
        noLocum:
          "Internal pool not available. Please contact your  group manager",
      },
      {
        label: `Preferred ${instance?.appContext.config.globalProperties.$filters.systemLocumName(
          false,
          true
        )}`,
        value: 2,
        description: `Preferred or Guest ${instance?.appContext.config.globalProperties.$filters.systemLocumName(
          false,
          false
        )}`,
        radioOption: "prefered_locum",
        percent: visibilityPreferredLocum,
        visibility: preferedLocumAvailable,
        noLocum: "Preferred locum not available",
      },
      {
        label: "Open marketplace",
        value: 3,
        description: `Available to all registered ${instance?.appContext.config.globalProperties.$filters.systemLocumName(
          false,
          false
        )}s`,
        radioOption: "open_marketplace",
        percent: visibilityAllLocum,
        visibility: true,
      },

      {
        label: "Agency",
        value: 4,
        description: "Notify your preferred agencies",
        radioOption: "agency",
        percent: visibilityAgencyUser,
        visibility: agenciesAvailable,
        noLocum: "Agencies not available. Please contact your  group manager",
      },
    ];

    const formsDataArray = reactive({
      userForm: {
        visibility_status: {
          value: jobCreatePageData.visibility_status
            ? jobCreatePageData.visibility_status
            : [],
        },
        // more_option_internal_pool:{
        //   value: jobCreatePageData.more_option_internal_pool
        //     ? jobCreatePageData.more_option_internal_pool
        //     :null,
        // },
        more_option_internal_pool: {
          value: {
            value: jobCreatePageData.more_option_internal_pool.value
              ? jobCreatePageData.more_option_internal_pool.value
              : null,
            guestLocums: jobCreatePageData.more_option_internal_pool.guestLocums
              ? jobCreatePageData.more_option_internal_pool.guestLocums
              : [],
            tags: jobCreatePageData.more_option_internal_pool.tags
              ? jobCreatePageData.more_option_internal_pool.tags
              : [],
          },
        },
        more_option_prefered_locum: {
          value: {
            value: jobCreatePageData.more_option_prefered_locum.value
              ? jobCreatePageData.more_option_prefered_locum.value
              : null,
            locums: jobCreatePageData.more_option_prefered_locum.locums
              ? jobCreatePageData.more_option_prefered_locum.locums
              : [],
          },
        },
        more_option_open_marketplace: {
          value: {
            value: jobCreatePageData.more_option_open_marketplace.value
              ? jobCreatePageData.more_option_open_marketplace.value
              : null,
            onboarding: jobCreatePageData.more_option_open_marketplace
              .onboarding
              ? 1
              : 0,
          },
        },
        more_option_agency: {
          value: {
            value: jobCreatePageData.more_option_agency.value
              ? jobCreatePageData.more_option_agency.value
              : null,
            agencies: jobCreatePageData.more_option_agency.agencies
              ? jobCreatePageData.more_option_agency.agencies
              : [],
          },
        },
      },
    });

    // Remove the "Open Marketplace" option directly from the array if isAus is true
    if (marketPlaceOff == true) {
      const index = visibiltyOptions.findIndex((option) => option.value === 3);
      if (index !== -1) {
        visibiltyOptions.splice(index, 1);
      }
    }

    const shouldDisableCheckbox = (visibilityOption) => {
      if (visibilityOption.value == 4 && agencies.value.length < 1) {
        return true; // disable the checkbox
      }
      if (visibilityOption.visibility && subscription.value) {
        return false; // Disable the checkbox
      }

      // Exception for "Open Marketplace" option
      if (visibilityOption.value === 3) {
        return false; // Enable the checkbox
      }

      // check if pharmacy is in group and group have active subscription for preferred locum option and preferred locum is enabled
      if(visibilityOption.value === 2 && 
        pharmacyIsInGroupAndGroupHaveSubscription.value && 
        visibilityOption.visibility &&
        isPreferredLocumEnabled
      ){
        return false;
      }

      return true; // Enable the checkbox
    };

    const checkSubscriptionEnabledDIsabled = (visibilityOption) => {
      if (subscription.value) {
        return false;
      }

      // Exception for "Open marketplace" option
      if (visibilityOption.value === 3) {
        return false;
      }

      // check if pharmacy is in group and group have active subscription for preferred locum option
      if(visibilityOption.value === 2 && pharmacyIsInGroupAndGroupHaveSubscription.value){
        return false;
      }

      return true;
    };

    const checkLocumAvailability = (visibilityOption) => {
      if (visibilityOption.visibility) {
        return false;
      }

      // Exception for "Open marketplace" option
      if (visibilityOption.value === 3) {
        return false;
      }
      return true;
    };

    const goBack = (formName) => {
      // $store.dispatch("clearJobCreatePageData");
      $store.dispatch("setJobCreatePageData", getFormValues(formName));
      // $router.push({
      //     name: "job_shift_access",
      // });
      $router.push({
        name: "additional_information",
      });
    };

    async function getGuestLocums() {
      const allGuestLocums = await $store.dispatch("GET_GUEST_LOCUMS_LIST");
      guestLocums.value = allGuestLocums.data;
    }

    async function getAgencies() {
      const allAgencies = await $store.dispatch("GET_AGENCIES");
      agencies.value = allAgencies.data;
    }

    async function getInternalEmployeeGroups() {
      const allInternalEmployeeGroups = await $store.dispatch(
        "GET_INTERNAL_EMPLOYEE_GROUPS"
      );
      internalEmployeeGroups.value = allInternalEmployeeGroups.data;
    }

    async function getPreferedLocums() {
      const allPreferedLocums = await $store.dispatch(
        "GET_PREFERED_LOCUMS_LIST"
      );
      preferedLocums.value = allPreferedLocums.data;
    }

    const isNextButtonDisabled = computed(() => {
      const visibilityStatus = formsData.userForm.visibility_status.value;
      const agencies = formsData.userForm.more_option_agency.value.agencies;
      const guestLocums =
        formsData.userForm.more_option_internal_pool.value.guestLocums;
      const preferedLocums =
        formsData.userForm.more_option_prefered_locum.value.locums;

      // Additional condition: Check if visibility_status contains 4 and agencies length is greater than 0
      const isGuestLocumValid = visibilityStatus.includes(1)
        ? guestLocums.length > 0
        : true;
      isGuestLocumValid;

      const isAgenciesValid = visibilityStatus.includes(4)
        ? agencies.length > 0
        : true;
      const isPreferedLocumsValid = visibilityStatus.includes(2)
        ? preferedLocums.length > 0
        : true;

      for (const status of visibilityStatus) {
        const option = visibiltyOptions.find((opt) => opt.value === status);

        if (option) {
          const optionValue = option.value;
          let moreOption = null;
          if (optionValue == 3) {
            moreOption =
              formsData.userForm[`more_option_${option.radioOption}`].value;
            if (
              optionValue !== null &&
              optionValue !== 0 &&
              (!moreOption.value ||
                moreOption.value === 0 ||
                moreOption.value === null)
            ) {
              return true;
            }
          }
          if (optionValue == 1 || optionValue == 2 || optionValue == 4) {
            moreOption =
              formsData.userForm[`more_option_${option.radioOption}`].value;
            if (
              optionValue !== null &&
              optionValue !== 0 &&
              (!moreOption.value ||
                moreOption.value === 0 ||
                moreOption.value === null)
            ) {
              return true;
            }
          }
        }
      }

      return (
        visibilityStatus.length === 0 ||
        !isAgenciesValid ||
        !isPreferedLocumsValid
      );
    });

    const agencyValue = computed({
      get: () => formsData.userForm.more_option_agency.value.value,
      set: (newValue) =>
        (formsData.userForm.more_option_agency.value.value = newValue),
    });

    const internalPoolValue = computed({
      get: () => formsData.userForm.more_option_internal_pool.value.value,
      set: (newValue) =>
        (formsData.userForm.more_option_internal_pool.value.value = newValue),
    });

    const preferedValue = computed({
      get: () => formsData.userForm.more_option_prefered_locum.value.value,
      set: (newValue) =>
        (formsData.userForm.more_option_prefered_locum.value.value = newValue),
    });

    function handleCheckboxClick(agencyId, event) {
      console.log("🚀 ~ handleCheckboxClick ~ event:", event);
      // if(!formsData.userForm.more_option_agency.value.agencies.includes(agencyId)){
      const selected = agencies.value.find((agency) => agency.id === agencyId);
      console.log("🚀 ~ handleCheckboxClick ~ selected:", selected);
      if (selected) {
        selectedAgencyData.value = {
          name: selected.name,
          email: selected.email,
          rates: selected.rate,
          notes: selected.notes,
        };
        showDialog.value = true;
      }
      // }
    }

    // function handleCheckboxClickGuestLocum(guestLocumId) {
    //     if(!formsData.userForm.more_option_internal_pool.value.guestLocums.includes(guestLocumId)){
    //       const selected = guestLocums.value.find((guestLocum) => guestLocum.id === guestLocumId);
    //       if (selected) {
    //         console.log('hello Guest Locums', selected)
    //         selectedAgencyData.value = {
    //           name: selected.name,
    //           email: selected.email,
    //         };
    //         showDialog.value = true;
    //       }
    //     }
    // }

    const handleCheckboxClickForOnboarding = () => {
      formsData.userForm.more_option_open_marketplace.value.onboarding =
        !formsData.userForm.more_option_open_marketplace.value.onboarding;
    };

    function calculateHourValue(futureDateStr, percentage) {
      // Convert the percentage to a decimal value
      const decimalPercentage = percentage / 100;

      // Split the date string into day, month, and year components
      const [day, month, year] = futureDateStr.split("/");

      // Create a new Date object using the day, month, and year
      const futureDate = new Date(`${year}-${month}-${day}`);

      // Get the current date and time
      const currentDate = new Date();

      // Calculate the time difference in milliseconds between the future date and the current date
      const timeDifference = futureDate.getTime() - currentDate.getTime();

      // Calculate the total hours from the time difference with three decimal places
      const totalHours = timeDifference / (1000 * 60 * 60);

      // Calculate the hour value based on the percentage
      const hourValue = totalHours * decimalPercentage;

      return parseFloat(hourValue.toFixed(0));
    }

    const updateVisibilityOptions = (selectedOptions) => {
      //  const lastDeselectedValue = prevVisibilityStatus.value.find((item) => !selectedOptions.includes(item));

      //   const lastSelectedValue = selectedOptions.length > 0 ? selectedOptions[selectedOptions.length - 1] : null;
      const previouslySelectedOptions = prevVisibilityStatus.value;
      // Determine deselected options
      const lastDeselectedValue = previouslySelectedOptions.filter(
        (option) => !selectedOptions.includes(option)
      );

      // Determine newly selected options
      const lastSelectedValue = selectedOptions.filter(
        (option) => !previouslySelectedOptions.includes(option)
      );

      if (
        formsData.userForm.visibility_status.value.includes(1) &&
        lastSelectedValue == 1
      ) {
        // If visibility_status includes 4, select all checkboxes
        // formsData.userForm.more_option_internal_pool.value.guestLocums = guestLocums.value.map(guestLocum => guestLocum.id);
        // formsData.userForm.more_option_internal_pool.value.tags = internalEmployeeGroups.value.map(internalEmployeeTag => internalEmployeeTag.id);
      }

      if (
        formsData.userForm.visibility_status.value.includes(4) &&
        lastSelectedValue == 4
      ) {
        // If visibility_status includes 4, select all checkboxes
        // formsData.userForm.more_option_agency.value.agencies = agencies.value.map(agency => agency.id);
      }

      if (
        formsData.userForm.visibility_status.value.includes(2) &&
        lastSelectedValue == 2
      ) {
        // If visibility_status includes 4, select all checkboxes
        // formsData.userForm.more_option_prefered_locum.value.locums = preferedLocums.value.map(locum => locum.id);
      }

      // Inselect case
      if (lastSelectedValue) {
        if (lastSelectedValue == 1) {
          formsData.userForm.more_option_internal_pool.value.value =
            calculateHourValue(
              jobCreatePageData.dates[0],
              visibilityInternalStaff
            );
          formsData.userForm.more_option_internal_pool.guestLocums =
            formsData.userForm.more_option_internal_pool.value.guestLocums ||
            [];
        } else if (lastSelectedValue == 2) {
          formsData.userForm.more_option_prefered_locum.value.value =
            calculateHourValue(
              jobCreatePageData.dates[0],
              visibilityPreferredLocum
            );
          formsData.userForm.more_option_prefered_locum.value.locums =
            formsData.userForm.more_option_prefered_locum.value.locums || [];
        } else if (lastSelectedValue == 3) {
          formsData.userForm.more_option_open_marketplace.value.value =
            calculateHourValue(jobCreatePageData.dates[0], visibilityAllLocum);
        } else if (lastSelectedValue == 4) {
          formsData.userForm.more_option_agency.value.value =
            calculateHourValue(
              jobCreatePageData.dates[0],
              visibilityAgencyUser
            );
          formsData.userForm.more_option_agency.value.agencies =
            formsData.userForm.more_option_agency.value.agencies || [];
        }
      }

      //Deselect case
      if (lastDeselectedValue) {
        if (lastDeselectedValue == 1) {
          formsData.userForm.more_option_internal_pool.value.value = null;
          formsData.userForm.more_option_internal_pool.value.guestLocums = [];
        } else if (lastDeselectedValue == 2) {
          formsData.userForm.more_option_prefered_locum.value.value = null;
          formsData.userForm.more_option_prefered_locum.value.locums = [];
        } else if (lastDeselectedValue == 3) {
          formsData.userForm.more_option_open_marketplace.value.value = null;
        } else if (lastDeselectedValue == 4) {
          formsData.userForm.more_option_agency.value.value = null;
          formsData.userForm.more_option_agency.value.agencies = [];
        }
      }

      prevVisibilityStatus.value = [...selectedOptions];
    };

    onMounted(() => {
      setPageClassGlobal("global_job_create_page_visibility");
      setFormRefs();
      getGuestLocums();
      getAgencies();
      getPreferedLocums();
      getInternalEmployeeGroups();
    });

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          $store.dispatch("setJobCreatePageData", getFormValues(formName));
          $router.push({
            name: "job_shift_access",
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const { getFormValues, setFormRefs, formsData, formsRefs } =
      formHooks(formsDataArray);

    return {
      formsData,
      goBack,
      goNext,
      visibiltyOptions,
      selectedInternalPoolOption,
      guestLocums,
      agencies,
      isNextButtonDisabled,
      updateVisibilityOptions,
      userRootData,
      user,
      agenciesAvailable,
      internalStaffAvailable,
      preferedLocumAvailable,
      calculateHourValue,
      internalPoolValue,
      agencyValue,
      handleCheckboxClick,
      selectedAgency,
      showDialog,
      selectedAgencyData,
      prevVisibilityStatus,
      preferedValue,
      preferedLocums,
      subscription,
      subscriptionAvailiabilityText,
      shouldDisableCheckbox,
      checkLocumAvailability,
      checkSubscriptionEnabledDIsabled,
      handleCheckboxClickForOnboarding,
      onboardingFeature,
      internalEmployeeGroups,
      isUS,
      message,
      pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText,
      pharmacyIsInGroupAndGroupHaveSubscription
      // handleCheckboxClickGuestLocum,
    };
  },
};
</script>
